import {
  LAT_LNG_COOKIE_NAME,
  NAVIGATION_FROM_APP_CODE,
  VENDOR_ID_COOKIE_NAME,
} from '@/constants/common'
import { APP_CODE_TYPE } from '@/models/Auth'

import { post } from '../axios'
import { getCookieValue } from '../helper'
import getClientCode from '../helpers/getClientCode'

interface AddNotifyMeProps {
  productId: number
  locale: string
  triggerSource: 'NOTIFYME' | 'WISHLIST'
}
export interface NotifyMeResponse {
  success: boolean
  message: string
}

interface ErrorCode {
  status: number
}

const addNotifyMe = async ({
  productId,
  locale,
  triggerSource,
}: AddNotifyMeProps) => {
  const vendorId = getCookieValue(VENDOR_ID_COOKIE_NAME)

  const latLng = getCookieValue(LAT_LNG_COOKIE_NAME)
  const clientCode = getClientCode(
    getCookieValue(NAVIGATION_FROM_APP_CODE) as APP_CODE_TYPE,
  )

  const url = '/hyperlocal/v1/notify'

  try {
    const result = await post<NotifyMeResponse>(url, {
      product_id: productId,
      vendor_id: vendorId,
      language: locale,
      app_source: clientCode === 'vr-service' ? 'vr_service' : clientCode,
      lat_lng: latLng,
      trigger_source: triggerSource,
    })
    return result
  } catch (e) {
    const err = e as ErrorCode
    if (err.status === 401) {
      return { success: false, message: 'Unauthorized' }
    }
    return { success: false, message: 'Something went wrong' }
  }
}
export default addNotifyMe
